const data = {
  data: [
    {
      id: 1,
      cif: 'A12345678',
      company_id: 7,
      name: 'empresa1',
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      link_date: '2021-05-25T15:33:57.000000Z'
    },
    {
      id: 2,
      cif: 'A12345678',
      company_id: 7,
      name: 'empresa2',
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      link_date: '2021-05-25T15:33:57.000000Z'
    },
    {
      id: 3,
      cif: 'A12345678',
      company_id: 7,
      name: 'empresa3',
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      link_date: '2021-05-25T15:33:57.000000Z'
    },
    {
      id: 4,
      cif: 'A12345678',
      company_id: 7,
      name: 'empresa 4',
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      link_date: '2021-05-25T15:33:57.000000Z'
    },
    {
      id: 5,
      cif: 'A12345678',
      company_id: 7,
      name: 'empresa 5',
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      link_date: '2021-05-25T15:33:57.000000Z'
    },
    {
      id: 6,
      cif: 'A12345678',
      company_id: 7,
      name: 'empresa 6',
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      link_date: '2021-05-25T15:33:57.000000Z'
    },
    {
      id: 7,
      cif: 'A12345678',
      company_id: 7,
      name: 'empresa 7',
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      link_date: '2021-05-25T15:33:57.000000Z'
    },
    {
      id: 8,
      cif: 'A12345678',
      company_id: 7,
      name: 'empresa 8',
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      link_date: '2021-05-25T15:33:57.000000Z'
    }
  ],
  links: {
    first: 'http://localhost/api/v1/businesses?page=1',
    last: 'http://localhost/api/v1/businesses?page=3',
    prev: null,
    next: 'http://localhost/api/v1/businesses?page=2'
  },
  meta: {
    current_page: 1,
    from: 1,
    last_page: 3,
    links: [
      {
        url: null,
        label: '&laquo; Anterior',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=1',
        label: '1',
        active: true
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: '2',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=3',
        label: '3',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: 'Siguiente &raquo;',
        active: false
      }
    ],
    path: 'http://localhost/api/v1/businesses',
    per_page: 20,
    to: 20,
    total: 41,
    search: {}
  }
}

export default data
